<ng-template #showLoader>
  <div class="loader" fxFill fxLayoutAlign="center center">
    <mat-spinner />
  </div>
</ng-template>

<ng-container *ngIf="isDicom$ | async; else imageSource">
  <pr-dicom-viewer
    *ngIf="media$ | async as dicomMedia"
    [media]="dicomMedia"
    [hideToolbar]="true"
  />
</ng-container>
<ng-template #imageSource>
  <ng-container *ngIf="loaded$ | async; else showLoader">
    <ng-container *ngIf="fileUrl$ | async as url; else fileIcon">
      <img [src]="url" />
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #fileIcon>
  <div
    *ngIf="fileExtension$ | async as extension"
    fxFill
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    <pr-media-file-icon [extension]="fileExtension$ | async" />
  </div>
</ng-template>

<div class="overlay" fxLayout="column">
  <div fxFlex class="tags">
    <pr-inline-tags-display size="sm" [tags]="namedDocsToTags.tags$ | async" />
  </div>

  <ng-container *ngIf="media$ | async as media">
    <div
      class="filename m-1 flex flex-col items-center justify-center rounded-sm"
    >
      @if (showImageName() && (isImage$ | async)) {
        <div class="w-full truncate text-center">
          {{ media.name | removeStorageUid }}
        </div>
      }
      @if (showFileName() && (isImage$ | async) === false) {
        <div class="w-full truncate text-center">
          {{ media.name | removeStorageUid }}
        </div>
      }
      @if (showDate()) {
        <span class="mat-caption">
          {{ media.createdAt | moment | amDateFormat: dateFormat }}
        </span>
      }
      <div
        *ngIf="media | map: hasExpired; else hasExpiry"
        class="flex items-center justify-center gap-2"
      >
        <mat-icon color="warn">warning</mat-icon>
        <div class="mat-caption expired">This media has expired</div>
      </div>
      <ng-template #hasExpiry>
        <div *ngIf="media.expiresAt" class="expiry mat-caption">
          Expires: {{ media.expiresAt | moment | amDateFormat: dateFormat }}
        </div>
      </ng-template>
    </div>
  </ng-container>
</div>
